import React, { useState, useEffect } from "react";
import { Col, Row } from "reactstrap";

const Section = (props) => {
    const [userDetails, setUserDetails] = useState({
        userName: "Guest User",
        title: "User",
        initials: "GU",
    });

    const [currentTime, setCurrentTime] = useState(new Date());

    useEffect(() => {
        const authData = sessionStorage.getItem("authUser");
        if (authData) {
            const parsed = JSON.parse(authData);
            const nameFinal = parsed?.name || "Guest User";
            const titleFinal = parsed?.title || "User";
            const initials = nameFinal
                .split(" ")
                .map((n) => n[0])
                .join("")
                .toUpperCase()
                .slice(0, 2);

            setUserDetails({ userName: nameFinal, title: titleFinal, initials });
        }
    }, []);

    useEffect(() => {
        const timer = setInterval(() => setCurrentTime(new Date()), 60000);
        return () => clearInterval(timer);
    }, []);

    const hour = currentTime.getHours();
    const greeting =
        hour < 12 ? "Good morning" : hour < 17 ? "Good afternoon" : "Good evening";

    const formattedDate = currentTime.toLocaleDateString("en-US", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
    });

    return (
        <React.Fragment>
            <Row className="mb-3 pb-1">
                <Col xs={12}>
                    <div style={styles.banner}>
                        {/* Left — Avatar + Greeting */}
                        <div style={styles.left}>
                            <div style={styles.avatar}>{userDetails.initials}</div>
                            <div>
                                <p style={styles.greeting}>{greeting},</p>
                                <h2 style={styles.name}>{userDetails.userName}!</h2>
                                <p style={styles.sub}>Welcome back to your dashboard</p>
                            </div>
                        </div>

                        {/* Right — Role Badge + Date */}
                        <div style={styles.right}>
                            <span style={styles.badge}>{userDetails.title}</span>
                            <p style={styles.date}>{formattedDate}</p>
                        </div>
                    </div>
                </Col>
            </Row>
        </React.Fragment>
    );
};

const styles = {
    banner: {
        background: "linear-gradient(135deg, #2b3f8c 0%, #493ddf 100%)",
        borderRadius: "16px",
        padding: "20px 28px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexWrap: "wrap",
        gap: "12px",
        marginRight: "26px",

    },
    left: {
        display: "flex",
        alignItems: "center",
        gap: "16px",
    },
    avatar: {
        width: "52px",
        height: "52px",
        borderRadius: "50%",
        background: "rgba(255,255,255,0.25)",
        border: "2px solid rgba(255,255,255,0.4)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "18px",
        fontWeight: "600",
        color: "#fff",
        flexShrink: 0,
    },
    greeting: {
        margin: 0,
        fontSize: "13px",
        color: "rgba(255,255,255,0.75)",
    },
    name: {
        margin: "2px 0 4px",
        fontSize: "20px",
        fontWeight: "700",
        color: "#fff",
    },
    sub: {
        margin: 0,
        fontSize: "12px",
        color: "rgba(255,255,255,0.6)",
    },
    right: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-end",
        gap: "6px",
    },
    badge: {
        background: "rgba(255,255,255,0.2)",
        color: "#fff",
        fontSize: "12px",
        padding: "4px 14px",
        borderRadius: "20px",
        border: "1px solid rgba(255,255,255,0.35)",
    },
    date: {
        margin: 0,
        fontSize: "12px",
        color: "rgba(255,255,255,0.7)",
    },
};

export default Section;